import { gql } from "graphql-tag"

const typeCommerce = gql`
  type CommerceProject {
    key: String
    name: String

    createdAt: DateTime
    createdBy: JSONObject

    lastModifiedAt: DateTime
    lastModifiedBy: JSONObject

    version: Int

    countries: [String]
    currencies: [String]
    languages: [String]
    trialUntil: String
    messages: JSONObject
    carts: JSONObject
    shoppingLists: JSONObject
    shippingRateInputType: JSONObject

    searchIndexing: JSONObject
    businessUnits: JSONObject
  }

  type Query {
    commerce: CommerceProject
  }
`

export { typeCommerce }

export default typeCommerce
